import DateRangeFilter from "../../components/DateRangeFilter/DateRangeFilter";
import FtmList from "./FtmList";

const HeaderView = ({
    selectedFtm,
    selectedDateRange,
    setSelectedFtm,
    setDateFilter,
    totalJobs,
    type = "financial"
}) => {

    const getHeaderTitle = () => {
        let parts = ["Financial"];

        if (selectedFtm?.label) {
            parts.push(selectedFtm.label);
        }

        if (selectedDateRange?.startDate && selectedDateRange?.endDate) {
            parts.push(`${selectedDateRange.startDate} - ${selectedDateRange.endDate}`);
        }

        return parts.join(" - ");
    };

    const handleResetDate = () => {
        setDateFilter(null); // or {} depending on your logic
    };

    return (
        <div className="row align-items-center">
            <div className="col-lg-6 col-12">
                <div className="ps-3">
                    <h6 className="text-uppercase text-white mb-0">
                        {getHeaderTitle()}
                    </h6>

                    {totalJobs !== undefined && (
                        <span className="financial-totalJobs text-bold">
                            Number of jobs : {Number(totalJobs).toLocaleString()}
                        </span>
                    )}
                </div>
            </div>

            <div className="col-lg-6 col-12 my-auto">
                <div className="d-flex justify-content-lg-end justify-content-start align-items-center gap-2 mt-2 mt-lg-0">

                    {type !== "valuation" && (
                        <FtmList
                            selectedFtm={selectedFtm}
                            setSelectedFtm={setSelectedFtm}
                        />
                    )}

                    {/* Date Filter + Reset */}
                    <div className="d-flex align-items-center gap-2">
                        <DateRangeFilter onChange={setDateFilter} />

                        <button
                            onClick={handleResetDate}
                            className="btn btn-sm d-flex align-items-center justify-content-center me-3"
                            title="Reset Date"
                            style={{height: "30px", width: "30px", marginTop: "12px"}}
                        >
                            <i class="material-icons text-light" style={{fontSize: "35px"}}>restart_alt</i>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default HeaderView;